<template>
  <div>
    <!-- 续费定额会员 -->
    <el-dialog :title="$t('message.renewalQuotaMember')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="488px" center>
      <div class="content">
        <p>设置后，到期前一天自动生效</p>
        <div class="row">
          <el-radio v-model="days" :label="0">第0档：0天 0円</el-radio>
        </div>
        <div class="row" v-for="(item, index) in list" :key="index">
          <el-radio v-model="days" :label="item.days">第{{ index + 1 }}档：{{ item.days }}天 {{ item.pay }}円</el-radio>
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    detail: { type: Object },
  },
  data() {
    return {
      dialogVisible: false,
      days: "",
      list: []
    };
  },
  created() {
    this.$api.clienteleApi.vipList().then(res => {
      this.list = res.data
    })
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.days = ''
      }
    }
  },
  methods: {
    // 保存
    save() {
      let datas = {
        user_id: this.$route.query.userID,
        pay_vip_continue: this.days,
      };
      this.$api.clienteleApi.setClientAutoPayVip(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$parent.clientDetail();
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  padding: 24px;
  background: #f8f8f8;
  border-radius: 8px;

  p {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 24px;
  }

  .row {
    margin-bottom: 24px;
  }

  /deep/.el-radio__input {
    transform: scale(1.5) !important;
  }
}
</style>